import { ElementType } from 'react';
import { Typography, WithChildren } from '@optimus-web/core';

interface TextMessagingLabelProps extends WithChildren {
    as: ElementType;
}

export const TextMessagingLabel: React.FC<TextMessagingLabelProps> = ({ as, children }) => (
    <Typography textStyle="bodyLargeStrong" as={as}>
        {children}
    </Typography>
);
